<template>
  <div class="login">
    <div class="image">
      <img src="../assets/loginBack.png" alt="" />
      <!-- 版本型号 :××××××××× 产出日期：××××××× 批准许可号：×××××× 执行标准：×××××××
      技术支持联系：北京卫新网络传播技术有限公司
      公司地址：北京市朝阳区广渠门外大街8号优士阁大厦A座12B06、12B07室 -->
      <section class="detail">
        <a-descriptions>
          <a-descriptions-item label="版本型号">
            2023-1.0版
          </a-descriptions-item>
          <a-descriptions-item label=" 产出日期"> 2023年12月1日 </a-descriptions-item>
          <!-- <a-descriptions-item label="批准许可号"> ×××××× </a-descriptions-item> -->
        </a-descriptions>
        <a-descriptions :column="3">
          <!-- <a-descriptions-item label="执行标准"> ××××××× </a-descriptions-item> -->
          <a-descriptions-item label="技术支持">
            北京卫新网络传播技术有限公司
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions :column="3">
          <a-descriptions-item label="公司地址">
            北京市朝阳区广渠门外大街8号优士阁大厦A座12B06、12B07室
          </a-descriptions-item>
        </a-descriptions>
      </section>
    </div>
    <a-row class="loginform">
      <div class="login-til">
        CSIAT
        <!-- <section class="login-title">
          抗菌药物(碳青霉烯类)治疗个体化计算系统
        </section>
        <section class="login-title2">
          Computing System for Individualization of antimicrobial therapy
        </section> -->
      </div>

      <a-form :model="loginInfo" @submit="loginButton" @submit.prevent class="form">
        <a-form-item label="用户名">
          <a-input
            class="login-input"
            size="large"
            placeholder="请输入用户名"
            v-model:value="loginInfo.username"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="密码">
          <a-input-password
            class="login-input"
            size="large"
            placeholder="请输入密码"
            type="password"
            autocomplete
            v-model:value="loginInfo.password"
          >
          </a-input-password>
        </a-form-item>
        <a-form-item>
          <a-button size="large" type="primary" html-type="submit" class="login-button">
            登录
          </a-button>
        </a-form-item>
      </a-form>
    </a-row>
  </div>
</template>

<script>
import { Options, Vue } from "vue-class-component";
import { UserOutlined, LockOutlined } from "@ant-design/icons-vue";
import { mapActions } from "vuex";
import Analytics from "@/utils/analytics";

@Options({
  components: {
    UserOutlined,
    LockOutlined
  },
  data() {
    return {
      loginInfo: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    ...mapActions("user", ["login"]),
    async loginButton() {
      try {
        await this.login(this.loginInfo);

        Analytics.LoginEvent(this.loginInfo.username, true);

        if (this.$route.query && this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          this.$router.push("/dashboard");
        }
      } catch (error) {
        Analytics.LoginEvent(this.loginInfo.username, false);

        if (error.non_field_errors) {
          this.$message.error(error.non_field_errors[0]);
        } else if (error.detail) {
          this.$message.error(error.detail);
        } else if (error.password) {
          this.$message.error(error.password);
        }
      }
    }
  }
})
export default class Login extends Vue {}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.login {
  width: 100%;
  height: 100%;
  display: flex;
  .image {
    width: 73%;
    height: 100%;
    position: relative;
    // background: pink;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .loginform {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}
.ant-form {
  padding: 0 40px;
  // margin-top: 180px;
}
.login-button {
  width: 100%;
  background: #3a36db;
  margin-top: 60px;
  font-size: 24px;

  height: 60px;
}
::v-deep .ant-input:hover,
::v-deep .ant-input:focus {
  // color: #3a36db;
  // color: red;
  border: 1px solid #3a36db;
}
.login-til {
  font-size: 100px;
  font-family: Source Han Sans CN;
  font-weight: 800;
  color: #3a36db;
  text-align: center;
  line-height: normal;
}
// .login-title {
//   font-size: 28px;
//   font-family: Microsoft YaHei UI;
//   font-weight: bold;
//   color: #080808;
//   // white-space: nowrap;
//   // margin-top: 180px;
//   text-align: center;
//   line-height: normal;
// }
// .login-title2 {
//   font-size: 14px;
//   font-family: Source Han Sans CN;
//   font-weight: 400;
//   color: #080808;
//   text-align: center;
//   line-height: normal;
// }
.login-input {
  // box-shadow: black 0px 0px 10px;
}
.detail {
  padding: 0 100px;
  position: absolute;
  bottom: 40px;

  // line-height: 30px;
}
::v-deep .ant-descriptions-item-label,
::v-deep .ant-descriptions-item-content {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
::v-deep .ant-descriptions-row > td,
::v-deep .ant-descriptions-row > th {
  padding-bottom: 0;
}
::v-deep .ant-descriptions-item {
  white-space: nowrap;
}
::v-deep .ant-form-item label {
  font-size: 24px;
}
::v-deep .ant-input:placeholder-shown,
::v-deep .ant-input-lg {
  font-size: 24px;
  height: 60px;
}
</style>
